import { Goal } from '../api/types';

export const MILESTONES = [20, 40, 50, 60, 80, 100] as const;
export type MilestoneStep = (typeof MILESTONES)[number];

const STORAGE_KEY = 'celebrated_milestones';

type Map = Record<string, number[]>;

function load(): Map {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object') return parsed as Map;
    return {};
  } catch {
    return {};
  }
}

function save(map: Map): void {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(map)); } catch { /* ignore */ }
}

/** Какие milestones цель уже пересекла (целочисленно). */
function reachedSteps(progressPct: number): MilestoneStep[] {
  return MILESTONES.filter((m) => progressPct >= m);
}

/** Инициализация: при первой загрузке отмечаем уже пройденные шаги без анимации. */
export function initCelebratedFromGoals(goals: Goal[]): void {
  const map = load();
  let changed = false;
  for (const g of goals) {
    if (!map[g.name]) {
      const pct = g.need > 0 ? (g.have / g.need) * 100 : 0;
      map[g.name] = reachedSteps(pct);
      changed = true;
    }
  }
  if (changed) save(map);
}

/**
 * Проверить пересечения milestone'ов после изменения.
 * Возвращает массив свежепересечённых шагов. Сохраняет факт празднования в localStorage.
 */
export function checkAndCelebrate(goalName: string, newProgressPct: number): MilestoneStep[] {
  const map = load();
  const known = new Set(map[goalName] ?? []);
  const reached = reachedSteps(newProgressPct);
  const fresh: MilestoneStep[] = [];
  for (const m of reached) {
    if (!known.has(m)) {
      fresh.push(m);
      known.add(m);
    }
  }
  if (fresh.length > 0) {
    map[goalName] = Array.from(known).sort((a, b) => a - b) as MilestoneStep[];
    save(map);
  }
  return fresh;
}
